module.exports = __webpack_public_path__ + "img/img_3dfield_original.9f172468.svg";